import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import propTypes from 'prop-types';
import { OptionList, Button, SwitchButton } from '../../../../component';
import { EconomyIcon, BusinessIcon, FirstIcon } from '~svg/index';
var temp = {};
const ChangeFlightPassengers = (props) => {
  const [cabinName, setCabinName] = useState(cabinClass || 'Economy');

  const {
    currentPage,
    passengers,
    INVALID_ROUTE,
    cabinClass,
    changePassengers,
    direction,
    intl,
  } = props;
  const renderChildTag = (item) => (
    <div
      style={{
        transform: direction === 'ltr' ? 'rotateY(0deg)' : 'rotateY(180deg)',
      }}
      className={`d-flex `}
    >
      {item}
    </div>
  );
  const returnCabinClassList = () => {
    return [
      {
        name: 'booking.economy',
        iconTag: renderChildTag(
          <EconomyIcon color={cabinName === 'Economy' ? '#fff' : '#6c757d'} />,
        ),
      },
      {
        name: 'booking.business',
        iconTag: renderChildTag(
          <BusinessIcon
            color={cabinName === 'Business' ? '#fff' : '#6c757d'}
          />,
        ),
      },
      {
        name: 'booking.first',
        iconTag: renderChildTag(
          <FirstIcon color={cabinName === 'First' ? '#fff' : '#6c757d'} />,
        ),
      },
    ];
  };
  temp = Object.assign(passengers);
  return (
    <React.Fragment>
      {/* <li className="d-flex align-content-start col flex-column  p-2 font-small">
        <div className="col-12 p-0 font-small"> */}
      <div className="changePassenger py-4 px-4 px-md-2 pt-md-3 pt-lg-4 pb-5 pb-md-0  w-100 px-0 text-gray mobile-background mobile-shadow ">
        <SwitchButton
          active={`booking.${cabinName ? cabinName.toLowerCase() : 'economy'}`}
          items={returnCabinClassList()}
          containerStyle="d-flex py-1 py-lg-0 cabin-type-border default-border-radius-xsmall bg-white 
                font-smaller font-xs-msmall font-sm-normal font-md-smaller font-lg-msmall font-xl-small font-xxl-normal"
          activeClass="bg-secondary "
          onclick={(item) => {
            setCabinName(item.charAt(0).toUpperCase() + item.slice(1));
          }}
          itmesStyle="py-2 py-lg-3"
          isRounded={true}
        />

        <div className="pt-3 d-flex w-100">
          <OptionList
            label="booking.guest"
            isAlwaysOpen={true}
            object={passengers}
            onClick={(change, key) => {
              optionListClick(change, key, passengers, changePassengers);
              props.openPassngerDropDown();
            }}
          />
        </div>
      </div>
      <div
        className="d-flex w-100 justify-content-center align-items-center flex-column position-absolute"
        style={{ bottom: 10 }}
      >
        {INVALID_ROUTE.includes(currentPage) && (
          <span className="d-flex col-12 text-danger font-smaller font-weight-bold py-2 text-center mt-2">
            <FormattedMessage
              id="booking.changepassengernotify"
              defaultMessage="booking.changepassengernotify"
            />
          </span>
        )}
        <div className="d-flex w-75">
          <Button
            name={`apply-changes`}
            id={`apply-changes`}
            onClick={() => {
              changePassengers(temp, cabinName);
            }}
            className="btn-secondary"
            label={intl?.formatMessage({
              id: 'profile.applyChanges',
            })}
            type="button"
          />
        </div>
      </div>
    </React.Fragment>
  );
};
//drop down for select and change
const optionListClick = (change, key, passengers, changePassengers) => {
  // Object.assign(temp, passengers);
  temp = Object.assign(passengers);
  if (change === 'inc') {
    let total_sum = temp['Adult'] + temp['Child(Age 2-12)'];
    // temp["senior(Over 65)"] +
    // temp["students(Over 18)"] +
    // temp["toddler(Age 0-2)"];
    // +
    // (parseInt(temp["students(Over 18)"]) || 0)
    if (
      (key === 'Adult' ||
        // key === "students(Over 18)" ||
        // key === "senior(Over 65)" ||
        // key === "toddler(Age 0-2)" ||
        key === 'Child(Age 2-12)') &&
      total_sum < 9
    ) {
      temp[key]++;
    } else if (
      key === 'Infant(Age 0-2)' &&
      (parseInt(temp['Adult']) || 0) >
        // (parseInt(temp["senior(Over 65)"]) || 0) >
        temp[key]
    ) {
      temp[key]++;
    }
  } else if (change === 'dec' && temp[key] !== 0) {
    if (
      // (parseInt(temp["senior(Over 65)"]) || 0) +
      // (parseInt(temp["students(Over 18)"]) || 0) +
      (parseInt(temp.Adult) || 0) - 1 > 0 &&
      temp[key] >= 1
    ) {
      temp[key]--;
      // If sum of Infant and Child is more then twofold of adult, We decrease child and infant fit to adult
      if (
        temp['Infant(Age 0-2)'] >
        // (parseInt(temp["senior(Over 65)"]) || 0) +
        // (parseInt(temp["students(Over 18)"]) || 0) +
        (parseInt(temp.Adult) || 0)
      ) {
        temp['Infant(Age 0-2)']--;
      }
    } else if (
      // ["Infant(Age 0-2)", "Child(Age 2-12)", "toddler(Age 0-2)"].indexOf(

      ['Infant(Age 0-2)', 'Child(Age 2-12)'].indexOf(key) !== -1
    )
      temp[key]--;
  }
};
//#region  prototype
ChangeFlightPassengers.propTypes = {
  currentPage: propTypes.string,
  passengers: propTypes.object,
  INVALID_ROUTE: propTypes.array,
};
//#endregion

//#region  defaultProps
ChangeFlightPassengers.defaultProps = {
  currentPage: '',
  passengers: {},
  INVALID_ROUTE: [],
};
//#endregion

export default ChangeFlightPassengers;
